import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";

// Define a service using a base URL and expected endpoints
export const apSubheaderAPI = createApi({
  reducerPath: "apSubheaderAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAPSummary: builder.query<any, APBackgroundArgTypes>({
      query: ({ apCode }) => ({
        url: `/am/ap/${apCode}/summary`,
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAPSummaryQuery
} = apSubheaderAPI;
